import { invariant } from "@/common/utils/invariant";

import { FullStrategy } from "./strategies/full.strategy";
import { TrialStrategy } from "./strategies/trial.strategy";

type Mode = "trial" | "full" | "not-available";

interface Strategy {
  canInteract: () => boolean;
  showCallToAction: () => boolean;
  getcompanyGetter: () => () => { id: string } | undefined;
}

/**
 * Marketplace interactions are restricted for users with trial version of the feature.
 * Users can view content and search, but cannot purchase items.
 */
class MarketplaceFlow {
  private currentStrategy: Strategy | undefined;
  private strategies: Map<Mode, Strategy>;

  constructor() {
    this.strategies = new Map<Mode, Strategy>([
      ["trial", new TrialStrategy()],
      ["full", new FullStrategy()],
    ]);
  }

  public setStrategy(mode: Mode) {
    const strategy = this.strategies.get(mode);
    // eslint-disable-next-line lingui/no-unlocalized-strings
    invariant(strategy, `Strategy for mode ${mode} does not exist`);
    this.currentStrategy = strategy;
  }

  public canInteract(): boolean {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    invariant(this.currentStrategy, "No current strategy available");
    return this.currentStrategy.canInteract();
  }

  public showCallToAction(): boolean {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    invariant(this.currentStrategy, "No current strategy available");
    return this.currentStrategy.showCallToAction();
  }

  public getCompanyGetter() {
    // eslint-disable-next-line lingui/no-unlocalized-strings
    invariant(this.currentStrategy, "No current strategy available");
    return this.currentStrategy.getcompanyGetter();
  }
}

export { MarketplaceFlow };
export type { Strategy };
